export const Design = [
    {
        key: 1,
        name: 'Xavier Manalo',
        image: require('static/team/design/xavier-manalo.png'),
        link: '',
    }, {
        key: 2,
        name: 'Emily Poon',
        image: require('static/team/design/emily-poon.png'),
        link: '',
    }, {
        key: 3,
        name: 'Summer Snellings',
        image: require('static/team/design/summer-snellings.jpg'),
        link: '',
    }, {
        key: 4,
        name: 'Tam Vo',
        image: require('static/team/design/tam-vo.png'),
        link: '',
    }, {
        key: 5, 
        name: 'David Xiong',
        image: require('static/team/design/david-xiong.jpg'),
        link: '',
    }, {
        key: 6, 
        name: 'Gloria Yun',
        image: require('static/team/design/gloria-yun.png'),
        link: '',
    },
];
